module.exports = __webpack_public_path__ + "static/EggPowder-2f9794c0cf803c706eeb21f19ab7952e.webp";